import { useState } from "react";
import { StandardComp } from "../atoms/standardComp";
import { Badge } from "../atoms/badges";
import { HorizontalLayout, VerticalLayout } from "./layout";

export function CustomerOrdersComp({ orders }) {
    const [ordersList, setOrdersList] = useState([
        { ordernr: "1234", date: "Feb 7, 2024 at 9:41am", status: "paid", price: "$129,99" },
        { ordernr: "1235", date: "Feb 8, 2024 at 10:00am", status: "paid", price: "$89,99" },
        { ordernr: "1236", date: "Feb 9, 2024 at 2:30pm", status: "paid", price: "$49,99" }
    ]);

    return (
        <StandardComp
         editClass={"customers-orders"}
            content={
                <>
                    <h5 className="small-standard-margin card-title">Customer orders</h5>
                     <th className="standard-text-color">
                            <th>Order</th>
                            <th>Status</th>
                            <th>Total</th>
                        </th>
                    <table className="co-table order-body">
                        {orders.map((item) => (
                            <tr key={item.ordernr}>
                                <td>
                                    #{item.id_orders_resellers}
                                    <br />
                                    <span>{item.date}</span>
                                </td>
                                <td>
                                    <Badge label={item.status? "Betaald":"Besteld"} rounded={true} badge={"succes"} />
                                </td>
                                <td>€{item.total_cost}</td>
                            </tr>
                        ))}
                    </table>
                </>
            }
        />
    );
}
